import React from 'react';
import { Route } from 'react-router-dom';
import { AccessRoleCard } from './AccessRoleCard';
import { AccessRoleEditDialog } from './access-role-edit-dialog/AccessRoleEditDialog';
import { AccessRoleUIProvider } from './AccessRoleUIContext';
import { PrivateRoute } from "../../../../PrivateRoute";
import { BlockOrg, RoleChecker } from '../../../../RoleChecker';


export function AccessRolePage({ history }) {

    const accessRoleUIEvents = {
        newAccessRoleButtonClick: () => {
            history.push('/access/access-role/new');
        },
        openEditAccessRolePage: (id) => {
            history.push(`/access/access-role/${id}/edit`);
        },
    };

    return (
        <AccessRoleUIProvider accessRoleUIEvents={accessRoleUIEvents}>

            <PrivateRoute role={BlockOrg() && RoleChecker('Create', 'access_role')} component={AccessRoleEditDialog}
                path="/access/access-role/new" />
            <PrivateRoute role={RoleChecker('Edit', 'access_role')} component={AccessRoleEditDialog}
                path="/access/access-role/:id/edit" />

            <Route path="/access/access-role/new">
                {({ history, match }) => (
                    <AccessRoleEditDialog
                        show={match != null}
                        onHide={() => {
                            history.push('/access/access-role');
                        }}
                    />
                )}
            </Route>

            <Route path="/access/access-role/:id/edit">
                {({ history, match }) => (
                    <AccessRoleEditDialog
                        show={match != null}
                        id={match && match.params.id}
                        onHide={() => {
                            history.push('/access/access-role');
                        }}
                    />
                )}
            </Route>

            <AccessRoleCard />
        </AccessRoleUIProvider>
    );
}
